import { Routes, Route } from "react-router-dom";
import Login from "./Login";
import Settings from "./Settings";
import Menu from "./Menu";
import ProtectedUrl from "./ProtectedUrl";
import PokemonList from "./PokemonList";
import Pokemon from "./Pokemon";
import { useSelector } from "react-redux";

const Pagination = () => {
  const theme = useSelector((state) => state.theme);

  return (
    <div className={`${theme} App-header  `}>
      <Menu />
      <div className="">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route element={<ProtectedUrl />}>
            <Route path="/pokedex" element={<PokemonList />} />
            <Route path="/pokedex/:id" element={<Pokemon />} />
            <Route path="/pokedex/:id/encounters" />
          </Route>
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </div>
    </div>
  );
};

export default Pagination;
